import { render, staticRenderFns } from "./statistics-vertical-card.vue?vue&type=template&id=3b609c73&scoped=true&"
import script from "./statistics-vertical-card.vue?vue&type=script&lang=js&"
export * from "./statistics-vertical-card.vue?vue&type=script&lang=js&"
import style0 from "./statistics-vertical-card.vue?vue&type=style&index=0&id=3b609c73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b609c73",
  null
  
)

export default component.exports